module.exports = __webpack_public_path__ + "assets/img/btn-back-9796d794.png";